import React from 'react';
import { Sparkle } from '@phosphor-icons/react';

const TIMEFRAMES = ['15m', '1h', '1D', '1W', '1M', '1Y'];
const INDICATORS = ['SMA20', 'SMA50', 'EMA9', 'Bollinger'];

export default function ChartToolbar({
  timeframe,
  onTimeframeChange,
  activeIndicators,
  onToggleIndicator,
  onRunPattern,
  detecting,
}) {
  return (
    <div className="flex flex-wrap items-center gap-4 mb-4">
      <div className="flex gap-1 border border-white/10 p-1" data-testid="timeframe-selector">
        {TIMEFRAMES.map((tf) => (
          <button
            key={tf}
            onClick={() => onTimeframeChange(tf)}
            className={`px-3 py-1 text-xs font-mono transition-colors ${
              timeframe === tf
                ? 'bg-[#2563EB] text-white'
                : 'text-[#94A3B8] hover:text-white hover:bg-white/[0.02]'
            }`}
            data-testid={`tf-${tf}`}
          >
            {tf}
          </button>
        ))}
      </div>

      <div className="flex gap-2 flex-wrap" data-testid="indicator-toggles">
        {INDICATORS.map((ind) => (
          <button
            key={ind}
            onClick={() => onToggleIndicator(ind)}
            className={`px-3 py-1 text-xs font-mono uppercase tracking-widest border transition-colors ${
              activeIndicators.includes(ind)
                ? 'border-[#2563EB] text-[#2563EB]'
                : 'border-white/10 text-[#64748B] hover:text-white'
            }`}
            data-testid={`ind-${ind}`}
          >
            {ind}
          </button>
        ))}
      </div>

      <button
        onClick={onRunPattern}
        disabled={detecting}
        className="ml-auto bg-[#A855F7] hover:bg-purple-600 text-white px-4 py-1.5 text-xs font-medium transition-colors disabled:opacity-50 flex items-center gap-2"
        data-testid="ai-pattern-btn"
      >
        <Sparkle size={16} weight="fill" />
        {detecting ? 'Analyzing...' : 'AI Pattern Detect'}
      </button>
    </div>
  );
}
